<ng-template #contentTemplate>
  <ng-content />
</ng-template>

@if (href) {
  <a [kbRouterOrExternalLink]="href">
    <ng-container *ngTemplateOutlet="contentTemplate" />
  </a>
} @else {
  <span>
    <ng-container *ngTemplateOutlet="contentTemplate" />
  </span>
}
